import { ExpandableInfo } from '@/components/encounter/review/expandable-info';
import styles from './otc-section.module.css';
import { useTranslation } from '@/contexts/i18n-context';
import { OtcProductAdModel, OtcProductModel, MarketingAdInfo } from '@/api/api.schemas';

interface OtcSectionProps {
  otcProducts: OtcProductModel[];
  otcProductsAds: OtcProductAdModel[];
  ads: MarketingAdInfo[];
  className?: string;
}

const translationBase = 'visit.treatmentPlan.otcProducts';

export function OtcSection({ otcProducts, otcProductsAds, ads, className }: OtcSectionProps) {
  const { t } = useTranslation();

  if (otcProducts.length === 0 && ads.length === 0) {
    return null;
  }

  return (
    <ExpandableInfo
      title={t(`${translationBase}.otcTitle`)}
      className={className}
      isOpen={ads.length > 0}
    >
      {otcProducts.length > 0 && (
        <div className={styles.otcItemsContainer}>
          {otcProducts.map((otc) => (
            <div key={otc.otcProductName} className={styles.otc}>
              {otc.imageLink && (
                <div className={styles.imageContainer}>
                  <img className={styles.img} alt={otc.otcProductName} src={otc.imageLink} />
                </div>
              )}
              <div className={styles.otcDescription}>
                <p className="semibold">{otc.otcProductName}</p>
                <p className="body-3">{otc.otcInstructions}</p>
              </div>
            </div>
          ))}

          {otcProductsAds.map((ad) => (
            <a key={ad.adLink} href={ad.adLink} target="_blank" rel="noreferrer">
              <img className={styles.adImage} alt={ad.adLocation!} src={ad.adLocation!} />
            </a>
          ))}
        </div>
      )}

      <MarketingSection ads={ads} />
    </ExpandableInfo>
  );
}

interface MarketingSectionProps {
  ads: MarketingAdInfo[];
}

function MarketingSection({ ads }: MarketingSectionProps) {
  return (
    <>
      {ads.map(
        (ad) =>
          ad.imageLink && (
            <a
              key={ad.imageLocation}
              href={ad.imageLink}
              target="_blank"
              rel="noreferrer"
              data-testid="treatment-plan-marketing-ad"
            >
              <img className={styles.adImage} alt="" src={ad.imageLocation} />
            </a>
          ),
      )}
    </>
  );
}
